export enum SettingsAdminCopilotDataEventObjectsEnum {
  ADMIN_COPILOT_FEEDBACK = 'admin_copilot_feedback',
  ADMIN_COPILOT_INPUT_MESSAGE = 'admin_copilot_input_message',
  ADMIN_COPILOT_FLOATING_PANEL_OPEN = 'admin_copilot_floating_panel_open',
  ADMIN_COPILOT_FLOATING_PANEL_COLLAPSE = 'admin_copilot_floating_panel_collapse',
  ADMIN_COPILOT_RESTART_CONVERSATION = 'admin_copilot_restart_conversation',
}
